export default __webpack_public_path__ + "static/kanha-celebration-bgimg-e7259c17809d0b7a692a0b425b201196.jpg";